<script setup>
import UTAFirmware from '@/components/UTAFirmware.vue'

const props = defineProps({

    fwName: {

        type: String,
        required: true
    }
})
</script>

<template>
    <div class="page page--firmware">
        <UTAFirmware :fwName="props.fwName" />
    </div>
</template>
